import { getChoiceId } from "./_common";

function printAttribute([name, value]) {
    return ` ${name}="${value}" `;
}

function objectToAttributes(object) {
    return Object.entries(object).map(printAttribute).join("");
}

function renderInput(props) {
    return `<input ${objectToAttributes(props)}/>`;
}

function renderOption({ title, value }) {
    return `<option value="${value}">${title}</option>`;
}

function renderSelect({ options, ...props }) {
    return `<select ${objectToAttributes(props)}>
  ${options.map(renderOption).join("")}
</select>`;
}

function enumToOptions(enumOption) {
    return { title: enumOption, value: enumOption };
}

function stringField(name, { format = "text", ...fieldProps }) {
    const enumOptions = fieldProps.enum;
    delete fieldProps.enum;

    if (Array.isArray(enumOptions)) {
        return renderSelect({ name, options: enumOptions.map(enumToOptions), ...fieldProps });
    }

    return renderInput({
        ...fieldProps,
        name,
        type: format,
    });
}

function booleanField(name, fieldProps) {
    delete fieldProps.type;
    return renderInput({
        ...fieldProps,
        name,
        type: "checkbox",
    });
}

function arrayField(name, { items, ...fieldProps }) {
    /**
     * NOTE: Right now the array fields used for custom fields
     * follow the following structure
     * [name]: {
     *    type: "array",
     *    items: {
     *      type: "string",
     *      enum: ['a', 'b', 'c']
     *    }
     * }
     * we should aim to follow the same structure here for propper
     * support
     **/
    const enumOption = items.enum;
    return renderSelect({
        ...fieldProps,
        name,
        options: enumOption.map(enumToOptions),
        multiple: true,
    });
}

const fieldRenderers = {
    boolean: booleanField,
    string: stringField,
    array: arrayField,
};

export function renderExtraField(requiredFields, [fieldName, { description, ...fieldProps }]) {
    const renderer = fieldRenderers[fieldProps.type];
    if (requiredFields.includes(fieldName)) fieldProps.required = true;
    fieldProps.placeholder = description;
    fieldProps["class"] = "listicle-voting-extra-field-input";

    return `<label class="listicle-voting-extra-field-label listicle-voting-extra-field-${fieldName}">
    <div class="listicle-voting-extra-field-label-wrapper">
        <span class="listicle-voting-extra-field-caption">${description || ""}</span>
        ${renderer(fieldName, fieldProps)}
    </div>
    <span class="listicle-voting-input-error hidden"></span>
</label>`;
}

export function renderChoice(postId, [choiceId, option]) {
    const id = getChoiceId(postId, choiceId);
    return `<div class="listicle-voting-choice-result">
    <label for="${id}">
        <span class="listicle-voting-choice-caption">${option || ""}</span> -
        <span class="listicle-voting-choice-caption-total"></span> votes
    </label>
    <progress id="${id}"></progress>
</div>`;
}
